import React from "react";
import HomeBanner from "../Assets/Images/HomeBanner.jpeg";
import About from "../Assets/Images/about.jpg";
import cryokotherapy from "../Assets/Images/cryokotherapy.jpg";
import cryo from "../Assets/Images/cryo.jpg";
import facial from "../Assets/Images/facial.jpg";
import targeted from "../Assets/Images/targeted.jpg";
import wellness from "../Assets/Images/Wellness.jpg";
import weightLoss from "../Assets/Images/Weightloss.jpg";
import painReduction from "../Assets/Images/Pain.jpg";
import beauty from "../Assets/Images/Beauty.jpg";
import Logo from "../Assets/Images/cryoko_logo.png";
import { useState } from "react";
import dayjs from "dayjs";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
  faYoutube,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { motion } from "framer-motion";
import {
  faSnowflake,
  faHeartbeat,
  faBolt,
  faShieldHeart,
  faPaperPlane,
  faArrowRight,
  faChevronRight,
  faLocationDot,
  faEnvelope,
  faPhone,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Form, Input, Button, notification } from "antd";
import {
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

const { TextArea } = Input;

export default function Home() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const GAS_URL =
    "https://script.google.com/macros/s/AKfycbzSVR72gM0Jzoi2KN-FUMzwshEEUKJehkpIUk8_g84WLg6181oYCWVBtx9gzAN-mA8nhA/exec";

  const services = [
    {
      image: cryokotherapy,
      title: "Whole Body Cryotherapy",
      badge: "Most Popular",
      rating: "⭐ 4.9",
      reviews: "250+ Reviews",
      description:
        "Experience whole-body cryotherapy in our advanced chamber designed to reduce inflammation, accelerate muscle recovery, improve circulation, boost metabolism, enhance energy levels, and help you feel refreshed after every session.",

      features: ["Pain Relief", "Faster Recovery", "Boost Metabolism"],
    },

    {
      image: facial,
      title: "Cryo Facial",
      badge: "Skin Care",
      rating: "⭐ 4.8",
      reviews: "180+ Reviews",
      description:
        "Revitalize your skin with a non-invasive Cryo Facial that stimulates collagen production, tightens pores, reduces puffiness, improves skin tone, and leaves your face naturally brighter and healthier.",

      features: ["Youthful Glow", "Collagen Boost", "Skin Tightening"],
    },

    {
      image: targeted,
      title: "Targeted Cryotherapy",
      badge: "Recovery",
      rating: "⭐ 4.9",
      reviews: "200+ Reviews",
      description:
        "Deliver precision cold therapy directly to muscles and joints for fast pain relief, reduced swelling, quicker injury recovery, improved flexibility, and enhanced athletic performance.",

      features: ["Sports Recovery", "Joint Pain", "Muscle Relief"],
    },
  ];

  const whyCryoko = [
    {
      title: "Wellness",
      image: wellness,
      description:
        "Restore your physical and mental wellbeing with advanced whole-body cryotherapy.",
    },
    {
      title: "Weight Loss",
      image: weightLoss,
      description:
        "Boost metabolism naturally and continue burning calories even after your session.",
    },
    {
      title: "Beauty",
      image: beauty,
      description:
        "Stimulate collagen production, tighten skin and reveal a youthful natural glow.",
    },
    {
      title: "Pain Relief",
      image: painReduction,
      description:
        "Reduce inflammation, relieve muscle soreness and recover faster from injuries.",
    },
  ];

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 80,
      scale: 0.96,
      filter: "blur(10px)",
    },

    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      filter: "blur(0px)",

      transition: {
        duration: 1.1,
        ease: [0.16, 1, 0.3, 1],
      },
    },
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const submittedAt = dayjs().format("DD-MM-YYYY HH:mm:ss");

      const payload = {
        action: "submitContact",

        name: values.name || "",

        phone: values.phone || "",

        email: values.email || "",

        subject: values.subject || "",

        message: values.message || "",

        submittedAt,
      };

      const formBody = new URLSearchParams(payload).toString();

      const response = await fetch(GAS_URL, {
        method: "POST",

        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },

        body: formBody,
      });

      const text = await response.text();

      let data = {};

      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Invalid server response");
      }

      if (data.success) {
        notification.success({
          message: (
            <span
              style={{
                color: "#0077D8",
                fontWeight: 700,
              }}
            >
              Message Sent
            </span>
          ),

          description: <span>Thank you! Our team will contact you soon.</span>,

          placement: "bottomRight",
        });

        form.resetFields();
      } else {
        throw new Error(data.error || "Submission failed");
      }
    } catch (err) {
      notification.error({
        message: (
          <span
            style={{
              color: "#d1343c",
              fontWeight: 700,
            }}
          >
            Submission Failed
          </span>
        ),

        description: <span>Something went wrong. Please try again.</span>,

        placement: "bottomRight",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = (id) => {
    const section = document.getElementById(id);

    if (section) {
      const navbarHeight = 100;

      const sectionPosition =
        section.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: sectionPosition - navbarHeight,
        behavior: "smooth",
      });
    }
  };

  const styl = `
 .ant-form-item .ant-form-item-label >label {
    position: relative;
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    height: var(--ant-form-label-height);
    color: #0077D8;
    font-weight: 700;
    font-size: var(--ant-form-label-font-size);
}`;

  return (
    <>
      <style>{styl}</style>
      <div className="container-fluid p-0 home-page">
        {/* Banner */}
        <div id="home" className="mt-5">
          <img
            src={HomeBanner}
            alt="Banner"
            className="img-fluid w-100 banner-img"
          />
        </div>

        {/* About Section */}

        {/* <section id="about" className="cryo-section">
          {" "}
          <div className="container">
            <div className="row align-items-center gy-5">

              <div className="col-lg-3 order-2 order-lg-1">
                <div>
                  <img
                    src={cryo}
                    className="img-fluid rounded-5"
                    alt="Cryotherapy"
                  />
                </div>
              </div>


              <div className="col-lg-9 order-1 order-lg-2">
                <span className="section-tag">CRYOTHERAPY</span>

                <h1 className="section-title">
                  Rejuvenate Your
                  <span> Body, Mind & Soul</span>
                </h1>

                <p className="section-desc">
                  Cryoko stands as Coimbatore's premier cryotherapy destination,
                  delivering luxury wellness experiences with the world's most
                  advanced whole-body cryotherapy chamber.
                </p>

                <p className="section-desc">
                  Whether you're recovering from intense workouts, reducing
                  inflammation, relieving arthritis, enhancing athletic
                  performance, slowing aging, or pursuing weight-loss goals, our
                  personalized recovery programs are designed to help you
                  achieve lasting wellness.
                </p>


                <div className="row mt-4">
                  <div className="col-sm-6 mb-4">
                    <div className="feature-card">
                      <FontAwesomeIcon
                        icon={faSnowflake}
                        className="feature-icon"
                      />

                      <div>
                        <h5>Advanced Cryotherapy</h5>
                        <p>World-class recovery technology.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6 mb-4">
                    <div className="feature-card">
                      <FontAwesomeIcon
                        icon={faHeartbeat}
                        className="feature-icon"
                      />

                      <div>
                        <h5>Health Recovery</h5>
                        <p>Reduce pain & inflammation.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6 mt-4 mt-lg-0">
                    <div className="feature-card">
                      <FontAwesomeIcon
                        icon={faBolt}
                        beat
                        className="feature-icon"
                      />

                      <div>
                        <h5>Boost Performance</h5>
                        <p>Recover faster & perform better.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6 mt-4 mt-lg-0">
                    <div className="feature-card">
                      <FontAwesomeIcon
                        icon={faShieldHeart}
                        className="feature-icon"
                      />

                      <div>
                        <h5>Premium Wellness</h5>
                        <p>Luxury wellness experience.</p>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="hero-buttons mt-4">
                  <button
                    className="btn-learn"
                    onClick={() => handleScroll("services")}
                  >
                    Learn More
                  </button>{" "}
                  <button
                    className="btn-book"
                    onClick={() =>
                      window.open(
                        "https://wa.me/919363507475?text=Hi%20Cryoko,%20I%20would%20like%20to%20book%20a%20Cryotherapy%20session.",
                        "_blank",
                      )
                    }
                  >
                    Book Session
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <motion.section
          id="about"
          className="cryo-section"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {" "}
          <div className="container">
            <div className="text-center">
              <span className="section-tag text-center">CRYOTHERAPY</span>

              <h1 className="section-title text-center">
                Rejuvenate Your <span>Body, Mind & Soul</span>
              </h1>

              <p className="section-desc">
                Cryoko stands as Coimbatore's premier cryotherapy destination,
                delivering luxury wellness experiences with the world's most
                advanced whole-body cryotherapy chamber. Whether you're
                recovering from intense workouts, reducing inflammation,
                relieving arthritis, enhancing athletic performance, slowing
                aging, or pursuing weight-loss goals, our personalized recovery
                programs are designed to help you achieve lasting wellness.
              </p>
            </div>
          </div>
          <div className="container-fluid mt-xl-5">
            {/* Image + Features */}
            <div className="row align-items-center mt-2 gy-5">
              {/* Image */}
              <div className="col-lg-5 m-0 p-0">
                <img
                  src={cryo}
                  className="img-fluid shadow aboutImage"
                  alt="Cryotherapy"
                />
              </div>

              {/* Features */}
              <div className="col-lg-7">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="feature-card h-100">
                      <FontAwesomeIcon
                        icon={faSnowflake}
                        className="feature-icon"
                      />
                      <div>
                        <h5>Advanced Cryotherapy</h5>
                        <p>World-class recovery technology.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="feature-card h-100">
                      <FontAwesomeIcon
                        icon={faHeartbeat}
                        className="feature-icon"
                      />
                      <div>
                        <h5>Health Recovery</h5>
                        <p>Reduce pain & inflammation.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="feature-card h-100">
                      <FontAwesomeIcon icon={faBolt} className="feature-icon" />
                      <div>
                        <h5>Boost Performance</h5>
                        <p>Recover faster & perform better.</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="feature-card h-100">
                      <FontAwesomeIcon
                        icon={faShieldHeart}
                        className="feature-icon"
                      />
                      <div>
                        <h5>Premium Wellness</h5>
                        <p>Luxury wellness experience.</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    {/* Buttons */}
                    <div className="hero-buttons mt-2 text-center">
                      <button
                        className="btn-learn"
                        onClick={() => handleScroll("services")}
                      >
                        Learn More
                      </button>

                      <button
                        className="btn-book"
                        onClick={() =>
                          window.open(
                            "https://wa.me/919363507475?text=Hi%20Cryoko,%20I%20would%20like%20to%20book%20a%20Cryotherapy%20session.",
                            "_blank",
                          )
                        }
                      >
                        Book Session
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        {/* Service Section */}
        <motion.section
          id="services"
          className="services-section"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {" "}
          <div className="container">
            <div className="services-heading">
              <span className="section-tag">OUR SERVICES</span>

              <h2>
                Premium Cryotherapy
                <span> Treatments</span>
              </h2>

              <p>
                Discover advanced recovery solutions designed to reduce pain,
                improve circulation, accelerate healing and elevate your overall
                wellness experience.
              </p>
            </div>

            <div className="row g-4 justify-content-center">
              {services.map((service, index) => (
                <div
                  className="col-12 col-md-6 col-lg-6 col-xl-4 d-flex justify-content-center"
                  key={index}
                >
                  <div className="service-card w-100 h-100">
                    {/* Image */}
                    <div className="service-image">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="img-fluid w-100"
                      />

                      {/* Category Badge */}
                      <div className="service-badge">{service.badge}</div>

                      {/* Rating */}
                      <div className="service-rating">
                        <span className="star">{service.rating}</span>
                        <small>{service.reviews}</small>
                      </div>
                    </div>

                    <div className="service-content">
                      <h3 className="service-title">{service.title}</h3>

                      <p className="service-description">
                        {service.description}
                      </p>

                      <div className="service-features">
                        {service.features.map((feature, i) => (
                          <div className="feature-pill" key={i}>
                            {feature}
                          </div>
                        ))}
                      </div>

                      <button className="service-btn">
                        Learn More
                        <span className="ms-2">→</span>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.section>

        {/* Why Croko Section */}
        <motion.section
          className="why-section mt-5"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {" "}
          {/* Animated Background */}
          {/* <div className="why-bg-circle circle-one"></div>
          <div className="why-bg-circle circle-two"></div> */}
          <div className="container">
            {/* Heading */}

            <div className="why-heading text-center">
              <span className="section-tag">WHY CHOOSE CRYOKO</span>

              <h2 className="why-title">
                Freeze Your
                <span> Age & Health</span>
              </h2>

              <p className="why-description">
                Cryoko combines cutting-edge cryotherapy technology with
                personalized wellness programs to help you recover faster, feel
                stronger and live healthier.
              </p>
            </div>

            <div className="row align-items-center gy-5">
              {/* Left Side */}

              <div className="col-lg-3">
                <div className="why-side">
                  <div className="why-card left-card">
                    <div className="why-image">
                      <img
                        src={wellness}
                        alt="Wellness"
                        className="img-fluid"
                      />
                    </div>

                    <h4>Wellness</h4>

                    <p>
                      Restore your body and mind while improving your overall
                      health.
                    </p>
                  </div>

                  <div className="why-card left-card">
                    <div className="why-image">
                      <img
                        src={weightLoss}
                        alt="Weight Loss"
                        className="img-fluid"
                      />
                    </div>

                    <h4>Weight Loss</h4>

                    <p>
                      Naturally boost metabolism and support healthy calorie
                      burning.
                    </p>
                  </div>
                </div>
              </div>

              {/* Center */}

              <div className="col-lg-6">
                <div className="why-center">
                  <div className="center-glow"></div>

                  <img
                    src={About}
                    alt="Cryotherapy"
                    className="img-fluid why-center-image"
                  />

                  <div className="experience-badge">
                    <h3>1000+</h3>

                    <span>Happy Clients</span>
                  </div>
                </div>
              </div>

              {/* Right */}

              <div className="col-lg-3">
                <div className="why-side">
                  <div className="why-card right-card">
                    <div className="why-image">
                      <img src={beauty} alt="Beauty" className="img-fluid" />
                    </div>

                    <h4>Beauty</h4>

                    <p>
                      Improve collagen production and reveal naturally healthier
                      skin.
                    </p>
                  </div>

                  <div className="why-card right-card">
                    <div className="why-image">
                      <img
                        src={painReduction}
                        alt="Pain Relief"
                        className="img-fluid"
                      />
                    </div>

                    <h4>Pain Relief</h4>

                    <p>
                      Reduce inflammation and recover quickly after every
                      session.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        {/* ================================
            CONTACT SECTION
         ================================ */}

        <motion.section
          id="contact"
          className="contact-section"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {" "}
          <div className="container-fluid m-0 p-0">
            {/* Heading */}

            <div className="contact-heading text-center">
              <span className="section-tag">CONTACT US</span>

              <h2>
                Get In <span>Touch</span>
              </h2>

              <p>
                We'd love to hear from you. Whether you have questions about
                Cryotherapy or would like to book a session, our team is here to
                help.
              </p>
            </div>

            <div className="row g-4 align-items-stretch">
              {/* ================= LEFT SIDE ================= */}

              <div className="col-lg-5">
                <div className="contact-info-box">
                  <h3>Contact Information</h3>

                  <p className="contact-text">
                    Feel free to reach out to us anytime. We usually respond
                    within 24 hours.
                  </p>

                  <div className="contact-list">
                    {/* Phone */}

                    <div className="contact-item">
                      <div className="contact-icon">
                        <PhoneOutlined />
                      </div>

                      <div>
                        <small>Phone</small>

                        <h6>+91 93635 07475</h6>
                      </div>
                    </div>

                    {/* Email */}

                    <div className="contact-item">
                      <div className="contact-icon">
                        <MailOutlined />
                      </div>

                      <div>
                        <small>Email</small>

                        <h6>cryoko@cryoko.com</h6>
                      </div>
                    </div>

                    {/* Address */}

                    <div className="contact-item">
                      <div className="contact-icon">
                        <EnvironmentOutlined />
                      </div>

                      <div>
                        <small>Address</small>

                        <h6>
                          9/1, Sriram Layout Rd,
                          <br />
                          Saibaba Colony,Coimbatore, <br />
                          Tamil Nadu 641011{" "}
                        </h6>
                      </div>
                    </div>

                    {/* Hours */}

                    <div className="contact-item">
                      <div className="contact-icon">
                        <ClockCircleOutlined />
                      </div>
                      <div>
                        <small>Working Hours</small>

                        <h6>All Days</h6>
                        <h6>10AM - 7PM</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ================= RIGHT SIDE ================= */}

              <div className="col-lg-7">
                <div className="contact-form-box">
                  <h3>Send Us a Message</h3>

                  <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    className="contact-form"
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <Form.Item
                          label="Full Name"
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "Please enter your name",
                            },
                            {
                              pattern: /^[A-Za-z\s]+$/,
                              message: "Name should contain only letters",
                            },
                          ]}
                        >
                          <Input size="large" placeholder="Your Name" />
                        </Form.Item>
                      </div>

                      <div className="col-md-6">
                        <Form.Item
                          label="Phone Number"
                          name="phone"
                          rules={[
                            {
                              required: true,
                              message: "Please enter phone number",
                            },
                            {
                              pattern: /^[+0-9\s]{10,20}$/,
                              message: "Enter a valid phone number",
                            },
                          ]}
                        >
                          <Input size="large" placeholder="Phone Number" />
                        </Form.Item>
                      </div>
                    </div>

                    <Form.Item
                      label="Email Address"
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your email",
                        },
                        {
                          type: "email",
                          message: "Enter a valid email",
                        },
                      ]}
                    >
                      <Input size="large" placeholder="Email Address" />
                    </Form.Item>

                    <Form.Item
                      label="Subject"
                      name="subject"
                      rules={[
                        {
                          required: true,
                          message: "Please enter subject",
                        },
                        {
                          max: 100,
                          message: "Subject cannot exceed 100 characters",
                        },
                      ]}
                    >
                      <Input size="large" placeholder="Subject" />
                    </Form.Item>

                    <Form.Item
                      label="Message"
                      name="message"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your message",
                        },
                        {
                          max: 300,
                          message: "Maximum 300 characters",
                        },
                      ]}
                    >
                      <TextArea rows={5} maxLength={300} showCount />
                    </Form.Item>

                    <Form.Item className="mb-0">
                      <Button
                        htmlType="submit"
                        className="contact-submit-btn"
                        loading={loading}
                      >
                        <span>{loading ? "Sending..." : "Submit Enquiry"}</span>

                        {!loading && (
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="submit-arrow"
                          />
                        )}
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        {/*=========================================
            PREMIUM FOOTER
==========================================*/}

        <motion.footer
          className="footer-section"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
          {" "}
          <div className="container">
            {/* Top CTA */}

            <div className="footer-cta">
              <div className="row align-items-center">
                <div className="col-lg-8">
                  <span className="footer-tag">
                    START YOUR WELLNESS JOURNEY
                  </span>

                  <h2>Recover Faster. Feel Better.</h2>

                  <p>
                    Experience premium cryotherapy treatments designed for
                    recovery, wellness and performance.
                  </p>
                </div>

                <div className="col-lg-4 text-lg-end">
                  <button
                    className="footer-book-btn"
                    onClick={() =>
                      window.open(
                        "https://wa.me/919363507475?text=Hi%20Cryoko,%20I%20would%20like%20to%20book%20a%20Cryotherapy%20appointment.",
                        "_blank",
                      )
                    }
                  >
                    Book a Quick Appointment
                    <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                  </button>
                </div>
              </div>
            </div>

            {/* Main Footer */}

            <div className="footer-main">
              <div className="row gy-5">
                {/*================================
                        BRAND
                ================================*/}

                <div className="col-lg-5 col-xl-4">
                  <div className="footer-card">
                    <img
                      src={Logo}
                      alt="Cryoko"
                      className="footer-logo img-fluid"
                    />

                    <p className="footer-about">
                      Cryoko combines cutting-edge cryotherapy technology with
                      luxury wellness experiences to help you recover, reduce
                      inflammation and improve your overall health.
                    </p>

                    <div className="footer-social">
                      <a href="https://www.facebook.com/cryoko.coimbatore/">
                        <FontAwesomeIcon icon={faFacebookF} />
                      </a>

                      <a href="https://www.instagram.com/cryoko_coimbatore/">
                        <FontAwesomeIcon icon={faInstagram} />
                      </a>

                      <a href="https://www.linkedin.com/company/cryokocoimbatore/">
                        <FontAwesomeIcon icon={faLinkedinIn} />
                      </a>

                      <a href="https://www.youtube.com/@cryokocoimbatore/">
                        <FontAwesomeIcon icon={faYoutube} />
                      </a>

                      <a href="https://x.com/Cryo_Coimbatore/">
                        <FontAwesomeIcon icon={faXTwitter} />
                      </a>
                    </div>
                  </div>
                </div>

                {/*================================
                    QUICK LINKS
                ================================*/}

                <div className="col-md-6 col-lg-3 col-xl-4">
                  <div className="footer-card">
                    <h4>Quick Links</h4>

                    <ul>
                      <li>
                        <a
                          onClick={() =>
                            window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                            })
                          }
                        >
                          <FontAwesomeIcon icon={faChevronRight} />
                          Home
                        </a>
                      </li>

                      <li>
                        <a onClick={() => handleScroll("about")}>
                          <FontAwesomeIcon icon={faChevronRight} />
                          About
                        </a>
                      </li>

                      <li>
                        <a onClick={() => handleScroll("services")}>
                          <FontAwesomeIcon icon={faChevronRight} />
                          Services
                        </a>
                      </li>

                      <li>
                        <a onClick={() => handleScroll("contact")}>
                          <FontAwesomeIcon icon={faChevronRight} />
                          Contact
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/*================================
                    OUR SERVICES
                ================================*/}

                {/* <div className="col-lg-3 col-md-4">

                    <div className="footer-card">

                        <h4>
                            Our Services
                        </h4>

                        <ul>

                            <li>
                                <a href="#">
                                    <FontAwesomeIcon icon={faChevronRight}/>
                                    Whole Body Cryotherapy
                                </a>
                            </li>

                            <li>
                                <a href="#">
                                    <FontAwesomeIcon icon={faChevronRight}/>
                                    Cryo Facial
                                </a>
                            </li>

                            <li>
                                <a href="#">
                                    <FontAwesomeIcon icon={faChevronRight}/>
                                    Targeted Cryotherapy
                                </a>
                            </li>

                            <li>
                                <a href="#">
                                    <FontAwesomeIcon icon={faChevronRight}/>
                                    Wellness Therapy
                                </a>
                            </li>

                        </ul>

                    </div>

                </div> */}

                {/*================================
                        CONTACT
                ================================*/}

                <div className="col-md-6 col-lg-4 col-xl-4 ">
                  <div className="footer-card">
                    <h4>Contact Us</h4>

                    <div className="footer-contact">
                      <div className="contact-box">
                        <FontAwesomeIcon icon={faLocationDot} />

                        <span>
                          9/1 Sriram Layout Road, Saibaba Colony, Coimbatore
                        </span>
                      </div>

                      <div className="contact-box">
                        <FontAwesomeIcon icon={faPhone} />

                        <span>+91 93635 07475</span>
                      </div>

                      <div className="contact-box">
                        <FontAwesomeIcon icon={faEnvelope} />

                        <span>cryoko@cryoko.com</span>
                      </div>

                      <div className="contact-box">
                        <FontAwesomeIcon icon={faClock} />

                        <span>
                          Everyday
                          <br />
                          10:00 AM – 7:00 PM
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom */}

            <div className="footer-bottom">
              <div className="row align-items-center">
                <div className="col-lg-12">
                  <p className="text-center">
                    © {new Date().getFullYear()} Cryoko. All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.footer>
        {/* Floating WhatsApp Button */}

        <a
          href="https://wa.me/919363507475?text=Hi%20Cryoko,%20I%20would%20like%20to%20know%20more%20about%20your%20Cryotherapy%20services."
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-float"
          aria-label="Chat on WhatsApp"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
          <span className="whatsapp-tooltip">Chat with us</span>
        </a>
      </div>
    </>
  );
}
